import React from "react";
import {ColumnLayout, Select} from "@amzn/awsui-components-react";
import {AGGREGATE_TYPES} from "../CalcDetails";

export class AggregateCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {...this.props.data};
  }

  handleChange = (change, e) => {
    const newState = {};
    newState[change] = e.detail.selectedId;
    this.setState(newState, () => {
      this.props.onChange({...this.state});
    })
  }

  render() {
    const groupSelection = this.props.columns.filter(x => x[1] === this.props.data.group_column_name);
    if (this.props.data.group_column_name !== 'None' && groupSelection.length === 0) {
      setTimeout(() => this.handleChange('group_column_name', {detail: {selectedId: 'None'}}));
    }
    const operationOptions = this.props.columns.filter(x => {
      if (this.props.data.group_column_name !== 'None' && groupSelection.length > 0) {
        return x[1].startsWith(this.props.data.group_column_name.split(".")[0]);
      }
      return true;
    });
    const operationSelection = operationOptions.filter(x => x[1] === this.props.data.column_name);
    return <ColumnLayout columns={2}>
      <div data-awsui-column-layout-root="true">
        <div>
          Group By Column:
          <Select options={[{label: "None", id: "None"}].concat(this.props.columns.map((x, ind) => {
            return {label: x[0], id: x[1]};
          }))}
                  selectedOption={{
                    label: groupSelection.length > 0? groupSelection[0][0]: "None",
                    id: groupSelection.length > 0? groupSelection[0][1]: "None",
                  }}
                  onChange={(e) => this.handleChange('group_column_name', e)}
                  selectedLabel="Selected"
                  filteringType={"auto"}
                  disabled={this.props.disabled}/>
        </div>
        <div>
          Operation Column:
          <Select options={operationOptions.map((x) => {
            return {label: x[0], id: x[1]};
          })}
                  selectedOption={{
                    label: operationSelection.length > 0? operationSelection[0][0]: "",
                    id: operationSelection.length > 0? operationSelection[0][0]: "",
                  }}
                  onChange={(e) => this.handleChange('column_name', e)}
                  selectedLabel="Selected"
                  filteringType={"auto"}
                  disabled={this.props.disabled}/>
        </div>
        <div>
          Operation:
          <Select options={AGGREGATE_TYPES.map((x) => {
            return {label: x, id: x};
          })}
                  selectedOption={{
                    label: this.props.data.operation,
                    id: this.props.data.operation
                  }}
                  onChange={(e) => this.handleChange('operation', e)}
                  selectedLabel="Selected"
                  disabled={this.props.disabled}/>
        </div>
      </div>
    </ColumnLayout>;
  }
}
